import { Link } from 'react-router-dom'
import Layout from '../../components/layout/Layout'
import { ASSETS } from '@/constants/assets'
import TransparentCard from '@/components/ui/transparent-card'
import ImageCard from '@/components/ui/image-card'
import WaveResonance from '@/components/ui/wave-resonance'

const ThoughtMindSync = () => {
  return (
    <Layout>
      <div className="w-full max-w-4xl px-4 md:px-8 lg:px-12 py-12 space-y-6">
        <h1 className="text-[2.488rem] font-semibold text-foreground font-sans tracking-[-0.025em] leading-[1.2] [text-wrap:balance]">
          Mind Sync: Exploring Neural Interface Design
        </h1>
        
        <p className="text-foreground text-[1.375rem] leading-[1.3] [text-wrap:balance]">
          A deep dive into the intersection of neuroscience and interface design, exploring how we can create more intuitive and responsive systems.
        </p>

        <WaveResonance />

        <div className="subline text-muted-foreground text-[0.875rem] leading-[1.2]">
          By{' '}
          <Link to="#" className="text-foreground no-underline hover:underline">
            Jean Mazouni
          </Link>{' '}
          in{' '}
          <Link to="#" className="text-foreground no-underline hover:underline">
            Research
          </Link>{' '}
          on December 16, 2024
        </div>

        <div className="blog-body space-y-4 text-foreground text-[1.125rem] leading-[1.625] [text-wrap:balance]">
          <p>
            The concept of neural interfaces has fascinated researchers and designers for decades. As we move towards more intuitive ways of human-computer interaction, understanding the principles behind neural interface design becomes increasingly important.
          </p>

          <div className="mt-12 flex flex-row gap-8 items-start">
            <div className="w-full md:w-1/4">
              <TransparentCard
                title="Neural Mapping"
                className="h-full w-full"
              />
            </div>
            <div className="w-full md:w-3/4 flex items-center">
              <p className="text-foreground text-lg leading-relaxed">
                Neural mapping is the process of understanding how different brain regions respond to various stimuli and commands. This knowledge is crucial for designing interfaces that can effectively interpret and respond to neural signals.
              </p>
            </div>
          </div>

          <div className="mt-12 grid grid-cols-1 md:grid-cols-2 gap-8">
            <div className="w-full">
              <ImageCard 
                src={ASSETS.images.mobileMock}
                alt="Neural interface prototype showing real-time brain activity visualization"
                isSquare
              />
            </div>
            <div className="w-full">
              <ImageCard 
                src={ASSETS.images.mobileMock}
                alt="Interface mockup demonstrating neural feedback loops"
                isSquare
              />
            </div>
          </div>

          <p className="mt-8 text-foreground text-lg leading-relaxed">
            The future of neural interfaces lies in creating systems that can seamlessly interpret and respond to our thoughts and intentions. This requires not just technological advancement, but also careful consideration of ethical implications and user experience design.
          </p>
        </div>
      </div>
    </Layout>
  )
}

export default ThoughtMindSync 